import { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as yup from 'yup';
import { Box, Button, debounce, Grid } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import { useAppDispatch, useAppSelector } from '../../../store';
import { clearClient, clearMessage, getClientAsync, getKiwiSaverRetentionClientAsync, setMessage } from '../../../store/adviser';
import KiwiSaverOnly from '../../application/KiwiSaverOnly';
import FormikWrapper from '../../containers/FormikWrapper';
import { Colors, SubtitleText, TitleText } from '../../controls/helpers';
import { TextInput } from '../../controls/inputs';
import { ClientStatuses } from '../../../api';
import { getRoles } from '../Helpers';

export default (props: RouteComponentProps) => {
    const { user } = useAppSelector(state => state.oidc);
    const { client, errors } = useAppSelector(state => state.adviser);
    const { clientId } = props.match.params as { clientId?: string };
    const dispatch = useAppDispatch();
    const roles = getRoles(user);
    
    useEffect(() => {
        !!errors && !client && dispatch(setMessage({ error: true, text: (errors.status === 400 && errors.title) || 'No active KiwiSaver account found with the provided KiwiSaver account number' }));
    }, [errors]);

    useEffect(() => {
        if (clientId) dispatch(getClientAsync(clientId));
    }, [clientId]);

    useEffect(() => {
        if (client?.emailInvitationSent || client?.smsInvitationSent || client?.clientStatus === ClientStatuses.Completed) {
            dispatch(clearClient());
            dispatch(setMessage({ error: true, text: `This KiwiSaver retention application has already been ${client.clientStatus === ClientStatuses.Completed ? 'completed by' : 'sent to'} the client.` }));
            props.history.replace('/adviser/onboarding-status');
        }
    }, [client]);

    const searchClients = debounce((kiwiSaverAccountNumber: string) => {
        dispatch(clearClient());
        dispatch(clearMessage());
        dispatch(getKiwiSaverRetentionClientAsync(kiwiSaverAccountNumber.trim()));
    }, 999);

    !roles.includes('KiwiSaver Retain Search') && props.history.replace('/adviser/onboarding-status');

    return <Box px={11} py={3}>
        <TitleText hideMarginBottom={!!client}>KiwiSaver retention tool</TitleText>
        {!client && !clientId &&
            <FormikWrapper
                enterSubmits
                validationSchema={yup.object({ kiwiSaverAccountNumber: yup.string().required('KiwiSaver account number is required') })}
                initialValues={{ kiwiSaverAccountNumber: '' }}
                onSubmit={({ kiwiSaverAccountNumber }) => searchClients(kiwiSaverAccountNumber)}>
                {({ resetForm }) => {
                    const clearForm = () => {
                        dispatch(clearClient());
                        dispatch(clearMessage());
                        resetForm();
                    }

                    useEffect(() => {
                        if (!client) resetForm();
                    }, [client]);

                    return <Grid container spacing={3}>
                        <Grid item sm={6} xs={12}>
                            <TextInput label="KiwiSaver account number" name="kiwiSaverAccountNumber" onChange={value => !value ? clearForm() : searchClients(value)} />
                        </Grid>
                        <Grid item md={3} sm={1} xs={12} />
                        <Grid item md={3} sm={5} xs={12} style={{ paddingTop: 36 }}>
                            <Button fullWidth color="primary" variant="contained" type="button" onClick={clearForm} endIcon={<RefreshIcon />}>Clear form</Button>
                        </Grid>
                    </Grid>
                }}
            </FormikWrapper>
        }
        {!!client && <>
            <Grid container spacing={3} alignItems="center">
                <Grid item md={9} sm={6} xs={12}>
                    <SubtitleText hideMarginBottom>
                        <span style={{ color: Colors.Black }}>KiwiSaver&emsp;</span>
                        {client.kiwiSaverApplication?.accountKey}
                    </SubtitleText>
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                    <Button fullWidth color="primary" variant="contained" type="button" onClick={() => { dispatch(clearClient()); dispatch(clearMessage()); }} endIcon={<RefreshIcon />}>Clear form</Button>
                </Grid>
            </Grid>
            <KiwiSaverOnly header="" route="kiwisaver-retention-tool" {...props} nextRoute={() => {}} />
        </>}
    </Box>
}
